/* Lampiero mouth tape v5 (8 Oct 2026): night-in-sound meter (nt-meter) and the morning check (nt-check). No visible text here. */
(function () {
  function qa(s, r) { return [].slice.call((r || document).querySelectorAll(s)); }
  function inView(el, fn) {
    if (!('IntersectionObserver' in window)) return fn();
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { io.disconnect(); fn(); } }); }, { threshold: 0.35 });
    io.observe(el);
  }
  function meter(m) {
    if (m.__nt) return; m.__nt = 1;
    var chart = m.querySelector('.nt5-m__chart'), n = 44, html = '';
    for (var i = 0; i < n; i++) {
      var o = 22 + 70 * Math.abs(Math.sin(i * 1.7)) * (0.55 + 0.45 * Math.abs(Math.sin(i * 0.23)));
      var c = 5 + 11 * Math.abs(Math.sin(i * 2.3)) * (i % 9 === 4 ? 1.6 : 1);
      html += '<i style="--o:' + o.toFixed(1) + '%;--c:' + c.toFixed(1) + '%;--d:' + (i * 14) + 'ms"></i>';
    }
    chart.innerHTML = html;
    var auto = true;
    function set(s) {
      m.setAttribute('data-s', s);
      qa('.nt5-tabs button', m).forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-s') === s)); });
    }
    qa('.nt5-tabs button', m).forEach(function (b) { b.addEventListener('click', function () { auto = false; m.classList.add('is-in'); set(b.getAttribute('data-s')); }); });
    inView(m, function () { m.classList.add('is-in'); setTimeout(function () { if (auto) set('closed'); }, 2600); });
  }
  function check(w) {
    if (w.__nt) return; w.__nt = 1;
    var items = qa('.nt5-q__i', w), res = w.querySelector('.nt5-q__res'), num = w.querySelector('[data-n]'), list = w.querySelector('.nt5-q__list');
    var min = parseInt(w.getAttribute('data-min'), 10) || 2, yes = 0, k = 0;
    function show(i) { items.forEach(function (li, j) { li.classList.toggle('is-on', j === i); }); if (num) num.textContent = String(i + 1); }
    items.forEach(function (li) {
      qa('button', li).forEach(function (b) {
        b.addEventListener('click', function () {
          if (b.getAttribute('data-a') === '1') yes++;
          k++;
          if (k < items.length) { show(k); return; }
          list.hidden = true; if (num) num.parentNode.hidden = true; res.hidden = false;
          var high = yes >= min;
          res.querySelector('[data-r="high"]').hidden = !high;
          res.querySelector('[data-r="low"]').hidden = high;
        });
      });
    });
    var again = w.querySelector('[data-again]');
    if (again) again.addEventListener('click', function () { yes = 0; k = 0; list.hidden = false; if (num) num.parentNode.hidden = false; res.hidden = true; show(0); });
  }
  function init() { qa('[data-nt-meter]').forEach(meter); qa('[data-nt-check]').forEach(check); }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
})();
